export const isAdvancedSearch = (searchStr: string): boolean => {
  const supportedKeywords = [
    "title",
    "tags",
    "author",
    "decription",
    "created_before",
    "created_after",
    "updated_before",
    "updated_after",
  ];

  return supportedKeywords.some((keyword) => searchStr.includes(`${keyword}:`));
};

export const getSearchPlaceholder = (): string => {
  const search_placeholders = process.env.NEXT_PUBLIC_SEARCH_PLACEHOLDERS;

  if (search_placeholders !== undefined && search_placeholders !== "") {
    const search_placeholders_list = search_placeholders.split(";");
    // we create the random index based on the current time in minutes, so every minute the placeholder will change
    const random_index =
      Math.floor(Date.now() / 1000 / 60) % search_placeholders_list.length;
    return search_placeholders_list[random_index];
  }

  return "Search...";
};
